import {
  Formfield,
  FormfieldProps,
} from '@designsystem/stories/03-molecules/Formfield';
import Checkbox from '../Checkbox/Checkbox';

export interface CheckboxGroupProps extends FormfieldProps {
  id?: string;
  name?: string;
  value?: string[];
  isDisabled?: boolean;
  isInvalid?: boolean;
  onChange?: (value: string[]) => void;
  options: Array<Array<string>>;
}

const CheckboxGroup = ({
  id,
  name,
  value,
  label,
  labelRequired,
  description,
  errorMessage,
  isRequired = false,
  isInvalid,
  isDisabled,
  onChange,
  children,
  options,
  ...props
}: CheckboxGroupProps) => {
  return (
    <Formfield
      label={label}
      description={description}
      isRequired={isRequired}
      labelRequired={labelRequired}
      errorMessage={errorMessage}
    >
      <ul className="unstyled">
        {options.map((option, i) => (
          <Checkbox
            key={i}
            name={id}
            value={value ? value.includes(option[0]) : undefined}
            label={option[1]}
            isInvalid={isInvalid}
            onChange={(checked) => {
              if (onChange) {
                if (checked) {
                  onChange([...(value || []), option[0]]);
                } else {
                  onChange(
                    (value || []).filter((val: string) => val !== option[0]),
                  );
                }
              }
            }}
          />
        ))}
      </ul>
    </Formfield>
  );
};

export default CheckboxGroup;
